import React from "react"
import { Link } from "gatsby"
import { navigate } from "gatsby"
const MetaButton = ({
  children = "Default Button",
  theme = "blue-bg",
  inverted = false,
  noBorder = false,
  disabled = false,
  dataEvent = { id: null },
  as,
  url,
  useNavigate = true,
  ...rest
}) => {
  let color = "",
    hcolor = "",
    background = "",
    hbackground = "",
    border = "",
    hborder = ""
  switch (theme) {
    case "blue-bg":
      color = inverted ? "text-dblue" : "text-white"
      hcolor = inverted ? "hover:text-dblue" : "hover:text-white"
      background = inverted ? "bg-mgreen" : ""
      hbackground = inverted ? "hover:bg-white" : ""
      border = inverted ? "" : "border-mgreen border-2"
      hborder = inverted ? "" : "hover:border-white border-2"
      break
    case "white-bg":
      color = disabled ? "text-slate-200" : "text-dblue"
      hcolor = disabled
        ? "text-slate-200"
        : inverted
        ? "hover:text-white"
        : "hover:text-dblue"
      background = inverted ? "bg-mgreen" : ""
      hbackground = inverted ? "hover:bg-dblue" : ""
      border = inverted || noBorder === true ? "" : "border-mgreen border-2"
      hborder = disabled || inverted ? "" : "hover:border-dblue border-2"
      break
    case "gray-bg":
      color = "text-dblue"
      hcolor = "hover:text-white"
      background = "bg-white"
      hbackground = "hover:bg-dblue"
      break
  }

  let extraClass = ""
  if (rest.type && rest.type === "small") {
    extraClass +=
      "desk:px-5 h-10 flex justify-center items-center min-w-[40px] min-h-[40px] !px-3"
  }

  const handleClick = event => {
    event.preventDefault()

    if (dataEvent.id) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "click_event " + dataEvent.id || "",

        eventAction: "click",
        ...dataEvent,
      })
    }

    if (url && useNavigate) {
      navigate(url)
    }

    if (url && !useNavigate && typeof window !== "undefined") {
      window.location.href = url
    }
  }
  const params = {
    "data-event-id": dataEvent && dataEvent.id ? dataEvent.id : "",
    disabled: disabled,
    ...rest,
    className: `${color} ${hcolor} ${background} 
      ${hbackground} ${border} ${hborder} 
      px-3 py-3 desk:px-4 py-2.5 desk:py-3 
      uppercase font-semibold font-inter  
      text-[14px] desk:leading-[18.2px] 
      text-center ${!disabled && "cursor-pointer"} inline-flex
      items-center justify-center
      desk:text-[18px] mt-3 grow-0 
      tracking-wide subpixel-antialiased 
      ${extraClass} ${rest.className || ""}
    `,
  }

  if (as === "link") {
    return (
      <Link to={url} {...params}>
        <div onClick={handleClick}> {children}</div>
      </Link>
    )
  }
  return (
    <button onClick={handleClick} {...params}>
      {children}
    </button>
  )
}

export default MetaButton
